import React from 'react';
import { VtexButton } from '../../styleguide/VtexButton';

const SearchFetchMore = ({ htmlElementForButton }) => {
	//aqui é show more mesmo

	return (
		<div className="buttonShowMore--layout vtex-search-result-3-x-buttonShowMore--layout w-100 flex justify-center">
			<div className="buttonShowMore vtex-search-result-3-x-buttonShowMore w-100 flex justify-center">
				<VtexButton href={htmlElementForButton === 'a'} size="small">
					Mostrar mais
				</VtexButton>
				{/* <button tabindex="0" class="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer " type="button">
                    <div class="vtex-button__label flex items-center justify-center h-100 ph5 " style="padding-top:.25em;padding-bottom:.32em">
                        Mostrar anteriores
                    </div>
                </button> */}
			</div>
		</div>
	);
};

export default SearchFetchMore;
